export const FEATURED_MEDIA_IMAGE_TYPE = 'image';
export const FEATURED_MEDIA_VIDEO_TYPE = 'video';
